import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE} from "@app/constants/Common";
import Select from "react-select";
import {capitalizeName, stringToOption} from "@app/utils/CommonUtils";
import {
    CddEmpFuNeededOptions,
    CddEmpProcessOptions,
    CddMeCheckStatusOptions, GdTTBHFuNeededOptions,
    GpEmpProcessOptions, JobFindModeOptions,
    MatchingPotentialOptions, PaymentAndWarrantyOptions,
    ProcessPriorityOptions,
    ReceiverCommentCddOptions,
    D1HighlightFields
} from '@pages/dvtjcuv/common/Constant';
import {requestCandidates} from "@app/services/CandidateService";
import {CddGPEmpDiscussionMode} from '@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionModal';
import {ReceiverCategoryOptions, ReceiveRequestOptions} from "@pages/candidate/detail/CandidateContactPoint";
import {findOneOptionByValue} from "@pages/dvtjcuv/common/PipelineUtil";
import {requestGetDVTJCUVPipeLineList} from "@pages/dvtjcuv/service/DVTJCUVPipelineService";

const DVTJCUVPipelineCddFields = [
    {key: 'cdd_id', label: 'Cdd ID', classNames: '', displayType: 'link', inputType: 'number', editable: true},
    {key: 'cdd_full_name', label: 'Họ và tên', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true},
    {key: 'cdd_displayed_company', label: 'Displayed Company', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true},
    {key: 'cdd_displayed_title', label: 'Displayed Title', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true},
    {
        key: 'cdd_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_industry',
        label: 'Industry',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_function',
        label: 'Function',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: true
    },
    {key: 'current_find_job_mode', label: 'Chế độ tìm job', classNames: '', displayType: 'text', inputType: 'option', isMulti: false, options: JobFindModeOptions, editable: false, capitalize: true, autoAdd: true},
    {key: 'current_find_job_mode_note_time', label: 'Note time (Chế độ tìm job)', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true},
];

export const DVTJCUVPipelineReceiverEmployerFields = [
    {key: 'cdd_receiver_id', label: 'Cdd Receiver ID', classNames: '', displayType: 'link', inputType: 'number', editable: true},
    {key: 'cdd_receiver_full_name', label: 'Họ và tên', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true},
    {key: 'cdd_receiver_displayed_company', label: 'Displayed Company', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true},
    {key: 'cdd_receiver_displayed_title', label: 'Displayed Title', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true},
    {key: 'cdd_receiver_local_province_email', label: 'Loca tỉnh (email)', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true},
    {key: 'cdd_receiver_industry', label: 'Industry', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true},
    {key: 'cdd_receiver_function', label: 'Function', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true},
    // {key: 'employer_id', label: 'Employer ID', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true},
    // {key: 'employer_name', label: 'Employer', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true},
    {key: 'candidate_receive_request', label: 'Yêu cầu nhận UV (DVTJCUV)', classNames: '', displayType: 'text', inputType: 'option', options: ReceiveRequestOptions, isMulti: true, editable: false},
    {key: 'cdd_receiver_category', label: 'Phân loại as a Cdd Receiver', classNames: '', displayType: 'text', inputType: 'option', options: ReceiverCategoryOptions, isMulti: true, editable: false, capitalize: true},
];

export const DVTJCUVPipelineDetailInfoFields = [
    {key: 'cdd_receiver_me_check_status',
         label: 'Trạng thái check ME của Cdd Receiver', classNames: '',
          displayType: 'text', inputType: 'option', searchable: true,
         editable: true, isMulti: false, options: CddMeCheckStatusOptions, color: 'text-primary'
    },
    {key: 'gp_emp_process', label: 'GP-Emp Process (Nhận UV)', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: GpEmpProcessOptions, color: 'text-primary'},
    {key: 'matching_potential', label: 'Tiềm năng Matching', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: MatchingPotentialOptions, color: 'text-primary'},
    {key: 'receiver_comment_cdd', label: 'Receiver nhận xét Cdd', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: ReceiverCommentCddOptions, color: 'text-primary'},
    {key: 'cdd_emp_process', label: 'Cdd-Emp Process', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: CddEmpProcessOptions, color: 'text-primary'},
    {key: 'job_id', label: 'Job', classNames: '', displayType: 'link', inputType: 'number', editable: true, link:'/job/edit/', searchable: true, color: 'text-primary'},
    {key: 'cdd_emp_fu_needed', label: 'FU needed (Cdd-Emp)', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: CddEmpFuNeededOptions, color: 'text-danger'},
    {key: 'cdd_emp_fu_schedule', label: 'FU Schedule (Cdd-Emp)', classNames: '', displayType: 'text', inputType: 'date', inputRange: true, searchable: true, editable: true, isMulti: true, color: 'text-danger'},
    {key: 'notes', label: 'Notes', classNames: '', displayType: 'text', inputType: 'textarea', searchable: true, editable: true, color: "text-success"},
    {key: 'note_with_cdd', label: 'Note with Cdd', classNames: '', displayType: 'text', inputType: 'text', searchable: true, editable: true, color: "text-success"},
    {key: 'process_priority', label: 'Ưu tiên xử lý', classNames: '', displayType: 'text', inputType: 'option', options: ProcessPriorityOptions, editable: true, color: "text-success"},
    {key: 'note_discussion_w_cdd', label: 'Note Discussion w Cdd', classNames: '', displayType: 'text', inputType: 'textarea', editable: true, autoAdd: false, capitalize: false, color: "text-info"},
    {key: 'note_discussion_w_receiver', label: 'Note Discussion w Receiver', classNames: '', displayType: 'text', inputType: 'textarea', editable: true, autoAdd: false, capitalize: false, color: "text-info"},
];

export const DVTJCUVPipelinePaymentWarrantyDetailInfoFields = [
    {key: 'payment_and_warranty', label: 'Thanh toán & Bảo hành', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: PaymentAndWarrantyOptions},
    {key: 'gd_tt_bh_fu_needed', label: 'FU needed (GĐ TT-BH)', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: GdTTBHFuNeededOptions, color: ''},
    {key: 'note_discussion_w_cdd', label: 'Note Discussion w Cdd', classNames: '', displayType: 'text', inputType: 'textarea', editable: true, autoAdd: false, capitalize: false},
    {key: 'note_discussion_w_receiver', label: 'Note Discussion w Receiver', classNames: '', displayType: 'text', inputType: 'textarea', editable: true, autoAdd: false, capitalize: false},
];

const InputCddGPEmpDiscussionContent = (props) => {
    const [pipeline, setPipeline] = useState({});
    const [pipelineDetailInfoFields, setPipelineDetailInfoFields] = useState(DVTJCUVPipelineDetailInfoFields);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {pipeLineInfo, mode, onChangeInputItem} = props

    const getProcessPriorityOption = (processPriority) => {
        if (processPriority) {
            return ProcessPriorityOptions.find(option => option.value.toString() === processPriority.toString())
        }
        return {label: "", value: ""}
    }

    const setPipelineInfoForDisplay = (inputPipeline) => {
        const pp = {...inputPipeline}
        pp.cdd_me_check_status = findOneOptionByValue(CddMeCheckStatusOptions, pp.cdd_me_check_status)
        pp.gp_cdd_process = stringToOption(pp.gp_cdd_process, true)
        pp.us_qualify_cdd = stringToOption(pp.us_qualify_cdd, true)
        pp.to_do_w_cdd = stringToOption(pp.to_do_w_cdd, true)
        pp.gp_emp_process = stringToOption(pp.gp_emp_process, false)
        pp.matching_potential = stringToOption(pp.matching_potential, false)
        pp.cdd_emp_process = stringToOption(pp.cdd_emp_process, false)
        pp.cdd_emp_fu_needed = stringToOption(pp.cdd_emp_fu_needed, true)
        pp.payment_and_warranty = stringToOption(pp.payment_and_warranty, false)
        pp.gd_tt_bh_fu_needed = stringToOption(pp.gd_tt_bh_fu_needed, true)
        pp.cdd_receiver_me_check_status = findOneOptionByValue(CddMeCheckStatusOptions, pp.cdd_receiver_me_check_status)
        pp.process_priority = getProcessPriorityOption(pp.process_priority)
        setPipeline({...pp})
    }

    const fetchCddReceiverDetail = async (canId, fieldKey) => {
        const params = {
            search_conditions: {
                candidate_id: canId
            }
        };

        const res = await requestCandidates(params);
        const candidates = res.content?.candidates;
        if (candidates && candidates.length > 0) {
            const can = candidates[0]
            if (fieldKey === 'cdd_id') {
                pipeline.cdd_id = canId
                if (can.personal) {
                    pipeline.cdd_full_name = capitalizeName(can.personal.full_name)
                }
                if (can.general) {
                    pipeline.cdd_displayed_company = can.general.displayed_company
                    pipeline.cdd_displayed_title = can.general.displayed_title
                }

                if (can.location) {
                    pipeline.cdd_local_province_email = can.location.local_province_email
                }

                if (can.categories) {
                    pipeline.cdd_industry = can.categories.industry
                    pipeline.cdd_function= can.categories.function
                }

                if (can.job_seeking) {
                    if (can.job_seeking.current_find_job_mode === 1) {
                        pipeline.current_find_job_mode = 'On'
                    }
                    else if (can.job_seeking.current_find_job_mode === 2) {
                        pipeline.current_find_job_mode = 'Off'
                    }

                    pipeline.current_find_job_mode_note_time= can.job_seeking.note_time
                }

            } else if (fieldKey === 'cdd_receiver_id') {
                pipeline.cdd_receiver_id = canId
                if (can.personal) {
                    pipeline.cdd_receiver_full_name = capitalizeName(can.personal.full_name)
                }
                if (can.general) {
                    pipeline.cdd_receiver_displayed_company = can.general.displayed_company
                    pipeline.cdd_receiver_displayed_title = can.general.displayed_title
                }
                if (can.location) {
                    pipeline.cdd_receiver_local_province_email = can.location.local_province_email
                }
                if (can.categories) {
                    pipeline.cdd_receiver_industry = can.categories.industry
                    pipeline.cdd_receiver_function= can.categories.function
                }
            }
            setPipeline({...pipeline})
        }
    };

    const fetchLatestPipeLineByCddAndReceiverId = async (canId, recId) => {
        const params = {
            search_conditions: {
                cdd_id: canId,
                cdd_receiver_id: recId,
            },
            sort_columns: {
                created_date_time: ODER_BY_TYPE.DESC
            }
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        const resPipelines = res.content.pipelines
        if (resPipelines && resPipelines.length > 0) {
            // const firstValidItem = resPipelines.find(item => !!item.cdd_receiver_id);
            const firstValidItem = resPipelines[0];
            if (firstValidItem) {
                DVTJCUVPipelineDetailInfoFields.forEach((item) => {
                    if (item.inputType === 'option') {
                        if (item.key === 'process_priority') {
                            pipeline[item.key] = firstValidItem[item.key];
                            // pipeline[item.key] = getProcessPriorityOption(firstValidItem[item.key]);
                        } else {
                            pipeline[item.key] = stringToOption(firstValidItem[item.key], item.isMulti);
                        }
                    } else {
                        pipeline[item.key] = firstValidItem[item.key];
                    }
                })

                setPipelineInfoForDisplay(pipeline)
            }
        }
    }

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }

        if (mode === CddGPEmpDiscussionMode.PAYMENT_AND_WARRANTY) {
            setPipelineDetailInfoFields(DVTJCUVPipelinePaymentWarrantyDetailInfoFields)
        }

    }, [])

    useEffect(() => {
        const fetchData = async () => {
            if (pipeLineInfo) {
                if (pipeLineInfo.cdd_id) {
                    await fetchCddReceiverDetail(pipeLineInfo.cdd_id, 'cdd_id');
                }
                if (pipeLineInfo.cdd_receiver_id) {
                    await fetchCddReceiverDetail(pipeLineInfo.cdd_receiver_id, 'cdd_receiver_id');
                }
                if (pipeLineInfo.cdd_id || pipeLineInfo.cdd_receiver_id) {
                    await fetchLatestPipeLineByCddAndReceiverId(pipeLineInfo.cdd_id, pipeLineInfo.cdd_receiver_id);
                }
            } else {
                setPipeline({});
            }
        };
        fetchData();
    }, [pipeLineInfo]);

    const onChangeInput = (values, column) => {
        pipeline[column.key] = values
        setPipeline({...pipeline})
        if (onChangeInputItem) {
            onChangeInputItem(values, column)
        }
    }

    const getItemValues = (column, values) => {
        return values || ""
    }

    const disableInputPipelineDetail = () => {
        return (!pipeline.cdd_id && !pipeline.cdd_receiver_id)
    }

    const onBlurInput = async (event) => {
        const fieldName = event.target.name
        if (fieldName === 'cdd_id' || fieldName === 'cdd_receiver_id') {
            await fetchCddReceiverDetail(event.target.value, fieldName)
        }
    }

    const disableCddFields = (column) => {
        return !column.editable || (column.key === 'cdd_id' && pipeLineInfo.id && pipeLineInfo.cdd_id);
    }

    const disableReceiverFields = (column) => {
        return !column.editable || (column.key === 'cdd_receiver_id'  && pipeLineInfo.id && pipeLineInfo.cdd_receiver_id);
    }

    const setFieldColorClass = (column) => {
        if (D1HighlightFields.includes(column.key)) {
            console.log(`setFieldColorClass:${column.key}`)
            return 'text-danger';
        }
        return column.color;
    }

    return (
        <div className={'row'}>
            <div className={'col-sm-4'}>
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title text-bold">Thông tin Cdd</h3>
                    </div>
                    <div className="card-body row">
                        {DVTJCUVPipelineCddFields.map(column => {
                            return <div className='col-sm-12' key={`DVTJCUVInputCddGPEmpDiscussionContent_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                    <input type={column.inputType} className='form-control'
                                           disabled={disableCddFields(column)}
                                           onBlur={onBlurInput}
                                           value={getItemValues(column, pipeline[column.key])}
                                           name={column.key} onChange={event => onChangeInput(event.target.value, column)}/>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>

            <div className={'col-sm-8'}>
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title text-bold">Thông tin Receiver & Employer</h3>
                    </div>
                    <div className="card-body row">
                        {DVTJCUVPipelineReceiverEmployerFields.map(column => {
                            return <div className='col-sm-6' key={`DVTJCUVInputCddGPEmpDiscussionContent_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                    <input type={column.inputType} className='form-control'
                                           onBlur={onBlurInput}
                                           disabled={disableReceiverFields(column)}
                                           value={getItemValues(column, pipeline[column.key])}
                                           name={column.key} onChange={event => onChangeInput(event.target.value, column)}/>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>

            <div className={'col-sm-12'}>
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title text-bold">Thông tin Pipeline</h3>
                    </div>
                    <div className="card-body row">
                        {pipelineDetailInfoFields.map(column => {
                            if (column.inputType === 'option') {
                                return <div className='col-sm-4' key={`DVTJCUVInputCddGPEmpDiscussionContent_input_item_${column.key}`}>
                                    <div className='form-group'>
                                        <div style={{width: '100%'}}>
                                            <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                            <Select options={column.options}
                                                    value={getItemValues(column, pipeline[column.key])}
                                                    isDisabled={(!column.editable || disableInputPipelineDetail())}
                                                    name={column.key}
                                                    isMulti={!!column.isMulti}
                                                    onChange={value => {
                                                        onChangeInput(value, column);
                                                    }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            return <div className='col-sm-4' key={`DVTJCUVInputCddGPEmpDiscussionContent_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                    <input type={column.inputType} className='form-control'
                                           disabled={(!column.editable || disableInputPipelineDetail())}
                                           value={getItemValues(column, pipeline[column.key])}
                                           name={column.key} onChange={event => onChangeInput(event.target.value, column)}/>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InputCddGPEmpDiscussionContent;
